<div class="header-label">
  <h2>Recovery Agents</h2>
</div>

<div class="top-controls-row">
  <mat-form-field appearance="outline" class="search-bar" subscriptSizing="dynamic">
    <mat-label>Search</mat-label>
    <input
      matInput
      [value]="searchTerm"
      (input)="onSearch(($any($event.target)).value)"
      placeholder="Type to search..."
      autocomplete="off"/>
    <button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch()">
      <mat-icon>close</mat-icon>
    </button>
    <mat-icon matPrefix>search</mat-icon>
  </mat-form-field>

  <button mat-flat-button color="primary" type="button" class="top-controls-action-btn" (click)="onAddRecoveryAgent()">Add Recovery Agent</button>
</div>

<div class="recovery-agents" *ngIf="resultVisibility">
  <div class="api-error-banner" *ngIf="listApiErrorMessage">
    {{ listApiErrorMessage }}
  </div>

  <div class="table-loader" *ngIf="loading">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>

  <div class="table-wrapper" [class.loading]="loading">

    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      [matSortActive]="sortBy"
      [matSortDirection]="sortDir"
      class="recovery-table"
    >
      <ng-container matColumnDef="View">
        <th mat-header-cell *matHeaderCellDef class="no-header"></th>
        <td mat-cell *matCellDef="let element" class="actions-cell">
          <button mat-icon-button type="button" matTooltip="View Details" class="table-action-btn" (click)="onView(element)" aria-label="View Recovery Agent">
            <mat-icon>visibility</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="Edit">
        <th mat-header-cell *matHeaderCellDef class="no-header"></th>
        <td mat-cell *matCellDef="let element" class="actions-cell">
          <button mat-icon-button type="button" matTooltip="Edit" class="table-action-btn table-action-edit" (click)="onEdit(element)" aria-label="Edit Recovery Agent">
            <mat-icon>edit</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="Delete">
        <th mat-header-cell *matHeaderCellDef class="no-header"></th>
        <td mat-cell *matCellDef="let element" class="actions-cell">
          <button mat-icon-button type="button" matTooltip="Delete" class="table-action-btn table-action-delete" (click)="onDelete(element)" aria-label="Delete Recovery Agent">
            <mat-icon>delete</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="RAMailingName">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Recovery Agent Mailing Name</th>
        <td mat-cell *matCellDef="let element">
          {{ element.RAMailingName }}
        </td>
      </ng-container>

      <ng-container matColumnDef="Street1">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Street 1</th>
        <td mat-cell *matCellDef="let element">
          {{ element.Street1 }}
        </td>
      </ng-container>

      <ng-container matColumnDef="Street2">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Street 2</th>
        <td mat-cell *matCellDef="let element">
          {{ element.Street2 }}
        </td>
      </ng-container>

      <ng-container matColumnDef="City">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>City</th>
        <td mat-cell *matCellDef="let element">
          {{ element.City }}
        </td>
      </ng-container>

      <ng-container matColumnDef="State">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>State</th>
        <td mat-cell *matCellDef="let element">
          {{ element.State }}
        </td>
      </ng-container>

      <ng-container matColumnDef="ZipCode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Zip Code</th>
        <td mat-cell *matCellDef="let element">
          {{ element.ZipCode }}
        </td>
      </ng-container>

      <ng-container matColumnDef="PaperlessInd">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Paperless Indicator</th>
        <td mat-cell *matCellDef="let element">
          {{ element.PaperlessInd }}
        </td>
      </ng-container>

      <ng-container matColumnDef="RecoveryAgentTaxID">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Tax ID</th>
        <td mat-cell *matCellDef="let element">
          {{ element.RecoveryAgentTaxID }}
        </td>
      </ng-container>

      <ng-container matColumnDef="OperatingCompany">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Operating Company</th>
        <td mat-cell *matCellDef="let element">
          {{ element.OperatingCompany }}
        </td>
      </ng-container>

      <ng-container matColumnDef="OfficeKey">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Office Key</th>
        <td mat-cell *matCellDef="let element">
          {{ element.OfficeKey }}
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <div *ngIf="dataSource.data.length === 0" class="no-results-message">
      No recovery agents found
    </div>
  </div>

  <mat-paginator
      #paginatorPageSize
      [length]="totalCount"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="pageSizes"
      (page)="onPageChange($event)"
      showFirstLastButtons
    ></mat-paginator>

</div>
